import React from "react";
// import axios from "axios";
// import urls from "../../Utils/urls";
import { useForm } from "react-hook-form";
// import { toast } from "react-toastify";
// import { commonToast } from "../../Utils";

const AddMenuItem = ({ close, refreshTable }) => {
  const { handleSubmit, register } = useForm();

  const onSubmit = (data) => {
  };

  return (
    <div className="mt-2">
      <form className="py-5 bg-white" onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <label htmlFor="menuItemName" className="form-label fw-bold">
                Menu Item Name
              </label>
              <textarea
                id="menuItemName"
                name="menuItemName"
                rows={3}
                className="form-control"
                {...register("menu_item_name", { required: true })}
              />
            </div>

            <div className="col-12 mb-4">
              <label htmlFor="modLevel" className="form-label fw-bold">
                Mod Level
              </label>
              <input
                id="modLevel"
                name="modLevel"
                type="text"
                className="form-control"
                {...register("mod_level", { required: true })}
              />
            </div>

            <div className="col-12 mb-4">
              <label htmlFor="parentMenuItem" className="form-label fw-bold">
                Parent Menu Item
              </label>
              <select
                id="parentMenuItem"
                name="parentMenuItem"
                className="form-select"
                {...register("parent_menu_item", { required: true })}
              >
                <option value=""></option>
                {/* {departmentOptions &&
                  departmentOptions?.map((option, index) => (
                    <option key={index} value={option.id}>
                      {option.product_name}
                    </option>
                  ))} */}
              </select>
            </div>

            <div className="col-6 mb-4">
              <label htmlFor="menuItemLink" className="form-label fw-bold">
                Menu Item Link
              </label>
              <input
                id="menuItemLink"
                name="menuItemLink"
                type="text"
                className="form-control"
                {...register("menu_item_link", { required: true })}
              />
            </div>

            <div className="col-6 mb-4">
              <label htmlFor="menuItemType" className="form-label fw-bold">
                Menu Item Type
              </label>
              <input
                id="menuItemType"
                name="menuItemType"
                type="text"
                className="form-control"
                {...register("menu_item_type", { required: true })}
              />
            </div>

            <div className="col-12 mb-4">
              <label
                htmlFor="menuItemDescription"
                className="form-label fw-bold"
              >
                Menu Item Description
              </label>
              <textarea
                id="menuItemDescription"
                name="menuItemDescription"
                rows={3}
                className="form-control"
                {...register("menu_item_description", { required: true })}
              />
            </div>

            <div className="col-6 mb-4">
              <label htmlFor="menuOrder" className="form-label fw-bold">
                Menu Order
              </label>
              <input
                id="menuOrder"
                name="menuOrder"
                type="text"
                className="form-control"
                {...register("menu_item_order", { required: true })}
              />
            </div>

            <div className="col-6 mb-4">
              <label className="form-label fw-bold">Is Active</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    id="isActiveYes"
                    name="isActive"
                    type="radio"
                    value="Yes"
                    className="form-check-input"
                    {...register("is_active", { required: true })}
                  />
                  <label htmlFor="isActiveYes" className="form-check-label">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    id="isActiveNo"
                    name="isActive"
                    type="radio"
                    value="No"
                    className="form-check-input"
                    {...register("is_active", { required: true })}
                  />
                  <label htmlFor="isActiveNo" className="form-check-label">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-5">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => close()}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary text-white">
            Add Item
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddMenuItem;
